import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { DataRepository } from "@/utilities/graphing/data-repository/repository";
import { staticImplements } from "@/utilities/static-implements";
import { DatesRange } from "@/utilities/types/dates-range";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { Adjustment } from "./parts/adjustment";
import { DataResponse } from "./data-response";

@staticImplements<ResponseModelInterfaceStatic>()
export class DataAdjustment implements DataResponse
{
    public constructor(
        public analyteIds: string[],
        public adjustments: Adjustment[],
    )
    {
    }

    /**
     * @inheritdoc
     */
    public static makeFromXml(elem: XmlElementWrapper): DataAdjustment
    {
        return new this(
            elem.firstChildByTag("analyteIds").translatedElemValues("analyteId"),
            elem.firstChildByTag("adjustments").mapForEachChildTag("adjustment", (subElem) => Adjustment.makeFromXml(subElem))
        );
    }

    /**
     * @inheritdoc
     */
    public fillDataRepository(dataRepository: DataRepository): void
    {
        for (let i = 0; i < this.adjustments.length; i++) {
            const repositoryAdjustment = dataRepository.adjustmentsData.getCurveAt(i);

            for (const cycle of this.adjustments[i].cycleData) {
                const cycleStats = cycle.statistics?.toGraphPredictionStatistics(cycle.start, cycle.end) ?? null;

                for (const [date, value] of cycle.getValuesByDate()) {
                    repositoryAdjustment.insertDataPoint(date, value, cycleStats);
                }

                repositoryAdjustment.available.add(new DatesRange(cycle.start, cycle.end));
            }
        }
    }

    /**
     * @inheritdoc
     */
    public fillGraphDataAdjustmentsRepository(): void
    {
        // Actually this is a NoOp method because it makes no sense to decode adjustment suggestions about an adjustment
        return;
    }
}
